import type { DashboardKpi } from '@/types/dashboard';

export const overviewKpis: DashboardKpi[] = [
  {
    id: 'members',
    label: 'Total members',
    value: '8,420',
    delta: '+12.4%',
    trend: 'up',
    icon: 'ri-group-line',
    note: 'vs last month',
    tone: 'primary',
  },
  {
    id: 'points',
    label: 'Points issued',
    value: '2.41M',
    delta: '+8.1%',
    trend: 'up',
    icon: 'ri-coins-line',
    note: 'vs last month',
    tone: 'accent',
  },
  {
    id: 'redemptions',
    label: 'Pending redemptions',
    value: '34',
    delta: 'needs review',
    trend: 'flat',
    icon: 'ri-gift-2-line',
    note: 'awaiting approval',
    tone: 'secondary',
  },
  {
    id: 'integrations',
    label: 'Active integrations',
    value: '12',
    delta: '+2',
    trend: 'up',
    icon: 'ri-plug-line',
    note: 'connected platforms',
    tone: 'background',
  },
];

export const pointsActivity = [
  { label: '1', earned: 268, redeemed: 112 },
  { label: '2', earned: 312, redeemed: 148 },
  { label: '3', earned: 284, redeemed: 96 },
  { label: '4', earned: 356, redeemed: 174 },
  { label: '5', earned: 402, redeemed: 188 },
  { label: '6', earned: 338, redeemed: 142 },
  { label: '7', earned: 296, redeemed: 120 },
  { label: '8', earned: 372, redeemed: 166 },
  { label: '9', earned: 418, redeemed: 204 },
  { label: '10', earned: 356, redeemed: 158 },
  { label: '11', earned: 302, redeemed: 132 },
  { label: '12', earned: 388, redeemed: 176 },
];

export const recentActivity = [
  {
    id: 'txn-10241',
    member: 'Ava Thompson',
    action: 'Redeemed',
    detail: 'Specialty Coffee Voucher',
    points: -1200,
    time: '2 min ago',
    type: 'redeem',
  },
  {
    id: 'txn-10240',
    member: 'Liam Chen',
    action: 'Earned',
    detail: 'Purchase on BloomCommerce',
    points: 340,
    time: '14 min ago',
    type: 'earn',
  },
  {
    id: 'txn-10239',
    member: 'Sofia Rossi',
    action: 'Earned',
    detail: 'Referral bonus',
    points: 500,
    time: '38 min ago',
    type: 'earn',
  },
  {
    id: 'txn-10238',
    member: 'Noah Patel',
    action: 'Redeemed',
    detail: '10% Discount Voucher',
    points: -800,
    time: '1 hr ago',
    type: 'redeem',
  },
  {
    id: 'txn-10237',
    member: 'Maya Fischer',
    action: 'Earned',
    detail: 'Signup bonus',
    points: 200,
    time: '2 hr ago',
    type: 'earn',
  },
  {
    id: 'txn-10236',
    member: 'Daniel Okafor',
    action: 'Adjusted',
    detail: 'Manual credit by admin',
    points: 150,
    time: '3 hr ago',
    type: 'adjust',
  },
];

export const topRewards = [
  {
    id: 'rwd-01',
    name: 'Specialty Coffee Voucher',
    category: 'Vouchers',
    points: 1200,
    redeemed: 412,
    stock: 88,
  },
  {
    id: 'rwd-02',
    name: '10% Discount Voucher',
    category: 'Vouchers',
    points: 800,
    redeemed: 336,
    stock: 250,
  },
  {
    id: 'rwd-03',
    name: 'Branded Merch Bundle',
    category: 'Merch',
    points: 2500,
    redeemed: 128,
    stock: 42,
  },
  {
    id: 'rwd-04',
    name: 'VIP Experience',
    category: 'Exclusive',
    points: 5000,
    redeemed: 47,
    stock: 12,
  },
];

export const integrationStatus = [
  { name: 'BloomCommerce', status: 'active', calls: '128,402' },
  { name: 'NovaMarket', status: 'active', calls: '94,118' },
  { name: 'Kartel', status: 'active', calls: '61,375' },
];
